import { GradientScrollDiv } from '@components/util/GradientScrollDiv';
import { useDebouncedValue } from '@lib/hooks/debounce';
import { videoPlayerStore, VideoPlayerStore } from '@stores/VideoPlayer';
import { observer } from 'mobx-react';
import css from './VisualDescriptionLoader.module.scss';

export type VisualDescriptions = {
  descriptions: {
    start: number;
    end: number;
    desc: string;
  }[];
};

export const VisualDescriptionLoader = observer(
  ({
    visualDescriptions,
    error,
    store = videoPlayerStore,
  }: {
    visualDescriptions: VisualDescriptions | null | undefined;
    error?: Error;
    store?: VideoPlayerStore;
  }) => {
    const debouncedCurrentTime = useDebouncedValue(store.currentTime, 50);

    if (error) {
      return <span className={css.placeholder}>Failed to load visual descriptions</span>;
    }

    if (visualDescriptions === null) {
      return <span className={css.placeholder}>No description available</span>;
    }

    if (!visualDescriptions) {
      return <span className={css.placeholder}>Loading...</span>;
    }

    const description = visualDescriptions.descriptions.find(
      (d) => d.start <= debouncedCurrentTime && d.end > debouncedCurrentTime,
    );

    return (
      <span className={css.rightPanelContent}>
        <GradientScrollDiv>{description?.desc || 'No description available'}</GradientScrollDiv>
      </span>
    );
  },
);
